import { changeAppState } from "../../../common/appState";
import { indexedDBStorage } from "../../../common/util/indexedDBStorage";
import { Plan, getPlanName } from "../../shared/User/types";
import { Benefit } from "./plans";

export const planSelectionPanelLastOpenedTimeStorageKey =
    "PlanSelectionPanelLastOpenedTimeStorageKey";

export async function saveCurrentDate() {
    await indexedDBStorage.setItemAsync(
        planSelectionPanelLastOpenedTimeStorageKey,
        Date.now().toString()
    );
}

export async function checkShouldOpenPlanSelectionPanel(): Promise<boolean> {
    const savedData = await indexedDBStorage.getItemAsync(
        planSelectionPanelLastOpenedTimeStorageKey
    );

    if (!savedData) {
        // 一度も開かれていない場合は今回は表示せず、9日後に表示
        await saveCurrentDate();
        return false;
    }

    const savedTimeNumber = Number(savedData);
    if (Number.isNaN(savedTimeNumber)) {
        // データが壊れている場合も今回は表示せず、9日後に表示
        await saveCurrentDate();
        return false;
    }

    const currentTimeNumber = Date.now();

    const diffMs = currentTimeNumber - savedTimeNumber;
    const thirteenDaysMs = 9 * 24 * 60 * 60 * 1000;

    return diffMs >= thirteenDaysMs; // 前回から9日分の時間が経っていれば true
}

export const openInsufficientChakraDialog = (
    message: string,
    requiredChakra: number,
    onButtonClick?: () => void
) => {
    changeAppState("simpleDialogState", {
        open: true,
        title: "Insufficient Chakra",
        message: message,
        buttonLabel: "Get Chakra",
        onButtonClick: () => {
            onButtonClick?.();
            changeAppState("chakraPurchasePanelState", {
                open: true,
                initialChakra: Math.ceil(requiredChakra / 10) * 10,
            });
            changeAppState("simpleDialogState", { open: false }); // Close the dialog
        },
        secondButtonLabel: "View Plans",
        onSecondButtonClick: () => {
            changeAppState("planSelectionPanelState", { open: true });
            changeAppState("simpleDialogState", { open: false });
        },
        buttonColor: "primary",
        secondButtonColor: "dark",
        dialogStyle: {
            height: "auto",
            maxHeight: "80vh",
            paddingBottom: 10,
        },
    });
};

export const openPlanUpgradeDialog = (
    requiredPlan: Plan,
    featureName: string,
    highlightedBenefit?: Benefit,
    options?: {
        title?: string;
        message?: string;
        buttonLabel?: string;
    }
) => {
    const planLabel = getPlanName(requiredPlan);
    changeAppState("simpleDialogState", {
        open: true,
        title: options?.title ?? "Upgrade Required",
        message:
            options?.message ??
            `To use the "${featureName}" feature, please upgrade to the ${planLabel} plan or higher.`,
        buttonLabel: options?.buttonLabel ?? "View Plans",
        onButtonClick: () => {
            changeAppState("simpleDialogState", { open: false });
            changeAppState("planSelectionPanelState", {
                open: true,
                selectedPlan: highlightedBenefit ? undefined : requiredPlan,
                highlightedBenefit,
            });
        },
        secondButtonLabel: "Close",
        onSecondButtonClick: () => {
            changeAppState("simpleDialogState", { open: false });
        },
        secondButtonColor: "dark",
        dialogStyle: {
            height: "auto",
            maxHeight: "80vh",
            paddingBottom: 10,
        },
    });
};
